import React from "react";
import ReactTable from "react-table";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import {Card, CardContent} from "@material-ui/core";

import {Objects} from "components";
import {cashDiscount} from "../../constants/Utilities";
const {UniversalModal} = Framework.Elements;

class TransactionEntries extends Framework.Components.Collection{
	constructor(props) {
		let model = new API.BuildClass(Types.Transactions_Entries._name, API.RequestType.READ_ALL);
		super(props, model);
		this.limit = 5;
		this.state.refundObject={};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if(prevState.data !== this.state.data){
			this.props.refundItems(this.state.data)
		}
	}

	// handleToggleRefund = (id, total, quantity, quantity_refunded, refund_amount, transaction, product = false) => (e) => {
	// 	this.state.refundObject = {
	// 		id: id,
	// 		total: total,
	// 		quantity: quantity,
	// 		quantity_refunded: quantity_refunded,
	// 		refund_amount: refund_amount,
	// 		transaction: transaction,
	// 		product: product,
	// 	}
	// 	this.toggle('modalRefund')();
	// }

	handleReload() {
		this.reloadTable();
		// this.props.refund();
	}

	render() {
		const {data, pages, limit, loading} = this.state;

		const columns = [
			//Todo:Flag consignment if it exists
			{
				Header: "Name",
				id: "name",
				accessor: r => {
					const host = "https://" + window.location.host;
					let href = host + "/trade-ins/" + r.inventory;
					if (r.transaction_type === "transaction_product") {
						href = "https://app.fflboss.com/products/" + r.pkey;
					} else if (r.transaction_type === "transaction_item") {
						href = host + "/inventory/" + r.inventory;
					} else if (r.transaction_type === "transaction_consignment") {
						href = host + "/consignments/" + r.inventory;
					} else if (r.transaction_type === "transaction_service") {
						href = host + "/services/" + r.inventory;
					}
					return (
						<a href={href} target={"_blank"} rel="noreferrer">
							{r.name}
						</a>
					);
				},
			},
			{
				Header: "Serial",
				id: "serial_number",
				className: 'center-column',
				accessor: r => (
					<span>
						{r.serial_number}
						<span className={"no-print"}>
							<Framework.Printable.Label
								ref={el => (this['printable' + r.pkey] = el)}
								prefix="P" code={r.pkey} label={r.serial_number}
							/>
						</span>
					</span>
				)
			},
			{
				Header: "SKU",
				id: "sku",
				className: 'center-column',
				accessor: r => r.sku
			},
			{
				Header: "Unit Price",
				id: "price",
				className: 'right-column',
				accessor: r => {
					let _discounted_unit_price = null;
					if (
						r.transactions?.cash_discount_amount && r.transactions?.cash_discount_amount !== "0.00" &&
						r.transactions?.cash_discount_percentage
					){
						//calculate cash discount for this item
						const {discounted_unit_price} = cashDiscount(r.transactions?.cash_discount_percentage, r.quantity, r.price)
						_discounted_unit_price = discounted_unit_price;
					}
					return <span>
						{(r.transaction_type === "transaction_trade" ? "" : _discounted_unit_price ?
							<span>
								{r.price}
								<i style={{color: 'red', paddingLeft: 5}}>({_discounted_unit_price})</i>
							</span>
							: r.price)}
					</span>
				}
			},
			{
				Header: "Quantity",
				id: "quantity",
				className: 'center-column',
				accessor: r => r.transaction_type === "transaction_product"  ? 1 : r.quantity
			},

			{
				//Todo: Can't sort this column.. If we could get the subtotal calculated on the backend, this could be fixed.
				Header: "Subtotal",
				id: "subtotal",
				className: 'right-column',
				accessor: r => {
					let _discounted_subtotal = null
					let _original_subtotal = null

					const quantity = parseFloat(r.quantity ?? 1)
					const price = parseFloat(r.price ?? 0)

					if (r.transaction_type === "transaction_trade") {
						_original_subtotal = (price * quantity).toFixed(2)

						return (
							<span style={{ color: "red" }}>
								{_original_subtotal}
							</span>
						)
					}

					_original_subtotal = (price * quantity).toFixed(2)

					if (
						r.transactions?.cash_discount_amount && r.transactions?.cash_discount_amount !== "0.00" &&
						r.transactions?.cash_discount_percentage
					) {
						const { discount_amount } = cashDiscount(
							r.transactions.cash_discount_percentage,
							quantity,
							price
						)

						const discountedSubtotal =
							(price * quantity) - discount_amount

						_discounted_subtotal = discountedSubtotal.toFixed(2)
					}

					return (
						<span>
							{_discounted_subtotal ? (
								<span>
									{_original_subtotal}
									<i style={{ color: "red", paddingLeft: 5 }}>
										({_discounted_subtotal})
									</i>
								</span>
							) : (
								_original_subtotal
							)}
						</span>
					)
				}
			},
			{
				//Todo: Test this once FFL Products are retrievable
				Header: "Discount",
				id: "discount_amount",
				className: 'right-column',
				 accessor: r =>  (r.discount_amount)
			},

			{
				Header: "Refunded",
				id: "refunded",
				className: 'center-column',
				accessor: (r) => {
					const refundedFlag =
						r.refunded === 1 || r.refunded === true || r.refunded === "1";
					if (r.transaction_type === "transaction_product") {
						return refundedFlag ? "Refunded" : "";
					}
					if (r.transaction_type === "transaction_trade") {
						return "";
					}
					const q = parseInt(r.quantity, 10);
					const saleQty = Number.isFinite(q) && q >= 1 ? q : 1;
					const rq = parseInt(r.refund_quantity, 10);
					const refundedQty = Number.isFinite(rq) ? Math.max(0, rq) : 0;
					if (refundedQty <= 0) {
						return "";
					}
					if (refundedFlag || refundedQty >= saleQty) {
						return "Refunded";
					}
					return `Partial (${refundedQty}/${saleQty})`;
				},
			}
		];
		return (
			<>
				<Card>

					<CardContent>
						<div className="row no-screen" >
							<div className={"col-8"}>
								<h1>Transaction {this.props.parent}</h1></div>
							<div className={"col-4 pull-right"} >
								{data[0] ?
									<div className={"no-screen"}
									     style={{textAlign: "right", width: "100%", fontSize: "1rem"}}>
										<strong>{data[0].transactions.locations.name} </strong><br/>
										{data[0].transactions.locations.store_number ? <div>{data[0].transactions.locations.store_number}</div> : null}
										{data[0].transactions.locations.phone ? <div>{data[0].transactions.locations.phone}</div> : null}
										{data[0].transactions.locations.email ? <div>{data[0].transactions.locations.email}</div> : null}
										{data[0].transactions.locations.street_1 ? <div>{data[0].transactions.locations.street_1}</div> : null}
										{data[0].transactions.locations.street_1 ?
											<div>{data[0].transactions.locations.city} {data[0].transactions.locations.state} {data[0].transactions.locations.zip}</div> : null}
									</div>
									: null}
							</div>
						</div>
						<div className="box-body">
							<div className="table-bar">
								<div className="d-flex no-print">
									{this.renderHeaderRight("Transaction Items", columns)}
								</div>
							</div>
							<ReactTable
								key={this.state.key}
								columns={columns}
								manual // Forces table not to paginate or sort automatically, so we can handle it server-side
								data={data}
								loading={loading} // Display the loading overlay when we need it
								loadingText="Requesting Data"
								onFetchData={this.fetchData} // Request new data when things change
								onSortedChange={this.onSortedChange}
								page={this.state.page}
								expanderDefaults={{
									sortable: true,
									resizable: true,
									filterable: false,
									width: undefined
								}}
								onExpandedChange={this.onExpandedChange}
								defaultSorted={[
									{
										id: this.model.sort,
										desc: this.model.order === 'desc'
									}
								]}
								showPagination={false}
								showPaginationTop={false}
								showPaginationBottom={false}
								showPageSizeOptions={false}
								defaultPageSize={data}
								pageSize={data}
								className="-striped -highlight"
							/>
						</div>

						{APPCONFIG.settings.isDev() ? null :
							<Framework.Elements.LoadingSpinner isLoading={loading}/>
						}

					</CardContent>
					{/*<UniversalModal*/}
					{/*	isDev={APPCONFIG.settings.isDev()}*/}
					{/*	// location={this.props.locations}*/}
					{/*	title={"Refund"}*/}
					{/*	name={"Refunds"}*/}
					{/*	submitLabel={"Refund"}*/}
					{/*	parent={this.props.parent}*/}
					{/*	object={Objects.TransactionRefund}*/}
					{/*	objectProps={{*/}
					{/*		entry: this.state.refundObject.id,*/}
					{/*		total: this.state.refundObject.total,*/}
					{/*		quantity: this.state.refundObject.quantity,*/}
					{/*		quantity_refunded: this.state.refundObject.quantity_refunded,*/}
					{/*		refund_amount: this.state.refundObject.refund_amount,*/}
					{/*		transaction: this.state.refundObject.transaction,*/}
					{/*		product: this.state.refundObject.product,*/}
					{/*		items: this.state.data*/}
					{/*	}}*/}
					{/*	history={this.props.history}*/}
					{/*	toggle={this.state.modalRefund}*/}
					{/*	reportClose={this.reportClose('modalRefund')}*/}
					{/*	afterSave={() => this.handleReload()}*/}
					{/*	size={'md'}*/}
					{/*	hideGoTo={true}*/}
					{/*/>*/}
				</Card>
			</>

		)
	}
}
export default Framework.Components.withRootState(TransactionEntries);
